// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logship-body {
  padding: 0 24px 24px;
}

.logship-subtitle {
  margin: 0 0 1rem;
  font-size: 0.85rem;
  color: #6b7280;
}

.logship-checked {
  white-space: nowrap;
}

.logship-legend {
  display: flex;
  gap: 0.75rem;
  font-size: 0.78rem;
  color: #6b7280;
}

.legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.dot {
  display: inline-block;
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 50%;
  background: #9ca3af;
  flex: 0 0 auto;
}

.dot-healthy {
  background: #16a34a;
}

.dot-warning {
  background: #f59e0b;
}

.dot-stale {
  background: #dc2626;
}

.dot-none {
  background: #9ca3af;
}

.dot-info {
  background: #7c3aed;
}

.logship-state {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1.5rem 0.5rem;
  color: #6b7280;
  font-size: 0.9rem;
}

.logship-state-error {
  color: #b91c1c;
}

.logship-table-wrap {
  overflow-x: auto;
}

.logship-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}
.logship-table th,
.logship-table td {
  text-align: left;
  padding: 0.6rem 0.75rem;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
}
.logship-table th {
  font-weight: 600;
  color: #374151;
  background: #f9fafb;
}

.company-cell {
  font-weight: 500;
}

.status-pill,
.stage-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: #f3f4f6;
  color: #374151;
}

.status-healthy {
  background: #ecfdf5;
  color: #065f46;
}

.status-warning {
  background: #fffbeb;
  color: #92400e;
}

.status-stale {
  background: #fef2f2;
  color: #991b1b;
}

.status-none {
  background: #f3f4f6;
  color: #6b7280;
}

.status-info {
  background: #f5f3ff;
  color: #5b21b6;
}

.stage-cell {
  vertical-align: top;
  min-width: 180px;
}

.cell-top {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.stage-age {
  font-variant-numeric: tabular-nums;
}

.stage-failing {
  color: #b91c1c;
  font-size: 0.75rem;
}

.file-status {
  padding: 0.05rem 0.4rem;
  border-radius: 4px;
  font-size: 0.7rem;
  background: #f3f4f6;
  color: #4b5563;
}

.file-status-loaded {
  background: #ecfdf5;
  color: #065f46;
}

.file-status-partial {
  background: #fffbeb;
  color: #92400e;
}

.file-status-failed {
  background: #fef2f2;
  color: #991b1b;
}

.file-status-scored {
  background: #f5f3ff;
  color: #5b21b6;
}

.cell-file {
  max-width: 240px;
  margin-top: 0.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.75rem;
  color: #4b5563;
}

.cell-file-info {
  color: #6d28d9;
}

.more-btn {
  margin-top: 0.2rem;
  padding: 0;
  font-size: 0.78rem;
}

.not-available {
  color: #9ca3af;
  font-size: 0.8rem;
  font-style: italic;
}

.more-note {
  margin: 0 0 0.75rem;
  color: #6b7280;
  font-size: 0.85rem;
}

.more-table .cell-file {
  max-width: 320px;
}

.expect-not_expected td,
.expect-retired td {
  color: #9ca3af;
}

.more-table td.row-status {
  white-space: normal;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
